export default {
  component: () => import('./page.vue'),
  path: '/arrhythmia/:batchId',
  alias: ['/report/:batchId', '/record/:batchId', '/ecg/:batchId'],
  name: 'arrhythmia',
  meta: {
    title: '心电分析报告',
    auth: true,
    wechat: {
      AppMessageShare: false,
      TimelineShare: false,
    },
  },
};
